import axios from 'axios'
import config from '../config'
import auth from './auth'
export default {


    getDeslindeSignatureByToken(token) {
        return axios.get(`${config.api_base_url}v1/inscripciones/deslindes/${token}`)
    },

    updateDeslindeSignature( data) {
        console.log(data);
        return axios.put(`${config.api_base_url}v1/inscripciones/deslindes/update`, data)
    },

}